__turbopack_context__.v({
  "root": "HsaFsaComponent-module__RSQSTG__root",
  "rootIp": "HsaFsaComponent-module__RSQSTG__rootIp",
});
